<script>
import AmsuScholarshipCard from "../AmsuScholarshipCard.vue";
import ScholarshipMeetingCommentApi from "../../Services/Api/MeetingApi/ScholarshipMeetingCommentApi";
import _ from "lodash";
import {mapActions, mapState} from "vuex";
import TheMeetingVoteCommentMenu from "../../Menu/TheMeetingVoteCommentMenu.vue";

export default {
  name: "MeetingVoteCommentCard",
  components: {
    AmsuScholarshipCard,
    TheMeetingVoteCommentMenu,
  },

  props: {
    achievement: Object,
    statement: {
      type: Object,
      default: {}
    },
  },

  data() {
    return {
      loadingVote: false,
      voteCommentRules: [
        v => !!v || "Обязательно к заполнению"
      ],
      isEditComment: false,
      editableCommentText: "",
    };
  },

  computed: {

    ...mapState({
      meeting: state => state.scholarship_meeting.meeting,
    }),

    comments() {
      return this.achievement?.comments || [];
    },

    comment() {
      return this.comments[0] || null;
    },

    sizePositiveVoteComment() {
      if(this.comments.length > 0) {
        return _.filter(this.comment.comment_votes, vote => vote.payload.status)?.length || 0
      }
    },

    sizeNegativeVoteComment() {
      if(this.comments.length > 0) {
        return _.filter(this.comment.comment_votes, vote => !vote.payload.status)?.length || 0
      }
    },

    idReviewer() {
      if (_.isEmpty(this.statement) || _.isNil(this.comments)) return null;
      return this.statement.reviewer.id
    },

    checkPositiveVote() {
      if (_.isEmpty(this.statement) || _.isNil(this.comments)) return true;
      return !_.isNil(
        _.find(this.comment.comment_votes, vote => vote.person_id === this.idReviewer && vote.payload.status)
      );
    },

    checkNegativeVote() {
      if (_.isEmpty(this.statement) || _.isNil(this.comments)) return true;

      return !_.isNil(
        _.find(this.comment.comment_votes, vote => vote.person_id === this.idReviewer && !vote.payload.status)
      );
    },

    heightCommentCard() {
      if (this.$vuetify.breakpoint.xlOnly) return '24vh';
      else return '10vh';
    },
  },

  methods: {
    ...mapActions({
      addVoteComment: 'scholarship_comment/addVoteComment',
      updateVoteComment: 'scholarship_comment/updateVoteComment',
    }),

    async voteBtnAction({idComment, status}) {
      this.loadingVote = true;

      if (this.checkPositiveVote || this.checkNegativeVote) {
        const vote = _.find(this.comment.comment_votes, vote => vote.person_id === this.idReviewer);
        await this.updateVoteComment({
          idComment: idComment,
          idVote: vote.id,
          comment: this.voteComment || null,
        })
      }
      else {
        await this.addVoteComment({idComment: idComment, status: status, comment: this.voteComment})
      }
      this.loadingVote = false;
    },

    async updateComment() {
      try {
        await ScholarshipMeetingCommentApi.update(this.meeting.id ,this.comment.id, this.editableCommentText);
        this.editableCommentText = "";
        this.isEditComment = false;
      } catch(err) {
        console.log(err);
      }
    },

    closeEditComment() {
      this.editableCommentText = "";
      this.isEditComment = false;
    },

    openEditComment() {
      this.isEditComment = true;
      this.editableCommentText = this.comment.comment_text;
    }
  }
}
</script>

<template>

  <v-card v-if="comments.length > 0" elevation="0">
    <v-card-title class="py-1 text-body-1 font-weight-bold">
      Комментарий к достижению

      <template v-if="!isEditComment">
        <v-btn @click="openEditComment" icon small>
          <v-icon small>
            fa-edit
          </v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-btn @click="updateComment" icon small>
          <v-icon small color="teal darken-3">
            fa-check
          </v-icon>
        </v-btn>
        <v-btn @click="closeEditComment" icon small>
          <v-icon small color="error">
            fa-times
          </v-icon>
        </v-btn>
      </template>

      <v-spacer/>
      <slot name="header-icon">
        <v-icon color="error" small>
          fa-exclamation
        </v-icon>
      </slot>
    </v-card-title>
    <v-list class="py-0">

      <v-list-item v-for="comment in comments" :key="comment.id">
        <v-list-item-content v-if="!isEditComment" class="py-0">
          <v-list-item-title
            :style="{'max-height': heightCommentCard}"
            class="d-flex text-wrap text-justify overflow-y-auto pr-1"
          >
            {{comment.comment_text}}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-icon small left>fa-comment</v-icon> {{comment.person_name}}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-textarea
          v-else
          label="Напишите комментарий"
          v-model="editableCommentText"
          :rules="voteCommentRules"
          color="teal darken-3"
          outlined
          class="rounded-xl"
        >
        </v-textarea>

      </v-list-item>
    </v-list>
    <v-card-actions class="py-0" v-if="!isEditComment">
      <v-spacer/>
      <v-btn
        x-small
        :disabled="checkPositiveVote"
        :loading="loadingVote"
        @click="voteBtnAction({
          status: true,
          idComment: comments[0].id
        })"
        color="teal darken-3"
        class="white--text rounded-xl"
      >
        {{sizePositiveVoteComment}} <v-divider class="mx-2" vertical/> За
      </v-btn>
      <div class="mx-3"></div>

      <the-meeting-vote-comment-menu
        :comment="comment"
        :check-negative-vote="checkNegativeVote"
        :size-negative-vote="sizeNegativeVoteComment"
        :check-positive-vote="checkPositiveVote"
        :id-reviewer="idReviewer"
      />
    </v-card-actions>


    <slot v-if="!isEditComment" name="bottom-comments">

    </slot>

  </v-card>

</template>

<style scoped>

</style>